<template>
  <eagle-list :list-key="listKey"></eagle-list>
</template>

<script lang="babel" type="text/babel">
import listMixin from '@/components/list/mixins/listMixin'
import listConfig from './cooperationProviderList'
export default {
  mixins: [listMixin],
  data: () => ({
    listKey: 'cooperation-provider-list',
    bindRoute: false,
    meta: {},
  }),
  methods: {
    async beforeIndex() {
      await Promise.all([])
    },
    async indexApi(params) {
      const member_id = this.$route.params.target
      return await this.$api.collection.memberApi.cooperation(params, member_id, 'provider')
    },
    // 解綁
    async deleteApi(target, row) {
      const member_id = this.$route.params.target
      return await this.$api.collection.providerMemberApi.delete(row.id, member_id)
    },
    // 批次解綁
    async batchDeleteApi(targets, selectedData) {
      // const pivot_ids = selectedData
      //   .filter(item => item.id == targets)
      //   .map(item => item.provider_pivot.id)
      // return await this.$api.collection.providerMemberApi.batchDelete(pivot_ids)
    },
    getListConfig() {
      return listConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
